import React from 'react'
import { observer } from 'mobx-react-lite'
import { MDBBtn, MDBIcon, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit'
import ContestStore, { WINNER_AMOUNT, NON_WINNER_AMOUNT } from '../Contest.store'
import AgentTypeahead from './AgentTypeahead.component'

const Contestants = observer(() => {
  const { contestants, isPreparing, isPlaying, isCompleted } = ContestStore

  // In playing/completed mode, only show visible contestants (actual participants)
  const displayContestants = isPlaying || isCompleted ? contestants.filter(c => c.visible) : contestants

  const handleAddAgent = agent => {
    if (ContestStore.contestants.find(c => c.user_id === agent.user_id)) {
      alert('This agent is already in the list.')
      return
    }
    ContestStore.addContestant(agent)
  }

  return (
    <div className='contestants-component'>
      <h5>Contestants ({ContestStore.visibleContestants.length} eligible)</h5>

      {isPreparing && (
        <div className='add-contestant-form mb-3'>
          <label className='mb-1 font-weight-bold'>Add Agent:</label>
          <AgentTypeahead onSelect={handleAddAgent} placeholder='Search agent by name...' />
        </div>
      )}

      <MDBTable striped bordered small responsive>
        <MDBTableHead>
          <tr>
            <th>#</th>
            <th>Agent Name</th>
            {!isPlaying && <th>User ID</th>}
            {(isPlaying || isCompleted) && <th>Award</th>}
            {isPreparing && <th>Source</th>}
            {!isPlaying && <th>Actions</th>}
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {displayContestants.map((contestant, idx) => (
            <tr
              key={contestant.user_id}
              className={
                !contestant.visible ? 'text-muted' : contestant.winnings === WINNER_AMOUNT ? 'table-success' : ''
              }
              style={!contestant.visible ? { opacity: 0.5, textDecoration: 'line-through' } : {}}
            >
              <td>{idx + 1}</td>
              <td>
                {contestant.u_name || `${contestant.u_fname || ''} ${contestant.u_lname || ''}`}
                {contestant.winnings === WINNER_AMOUNT && <MDBIcon icon='trophy' className='text-warning ml-2' />}
              </td>
              {!isPlaying && <td>{contestant.user_id}</td>}
              {(isPlaying || isCompleted) && (
                <td>
                  {contestant.winnings === WINNER_AMOUNT ? (
                    <span className='text-success font-weight-bold'>${WINNER_AMOUNT}</span>
                  ) : isCompleted && contestant.visible ? (
                    <span className='text-info font-weight-bold'>${NON_WINNER_AMOUNT}</span>
                  ) : (
                    '-'
                  )}
                </td>
              )}
              {isPreparing && <td>{contestant.manuallyAdded ? 'Manual' : 'Bar-Breaker'}</td>}
              {!isPlaying && (
                <td>
                  {isPreparing && (
                    <>
                      <MDBBtn
                        type='button'
                        color={contestant.visible ? 'warning' : 'success'}
                        size='sm'
                        className='px-2 py-1 mr-1'
                        onClick={() => ContestStore.toggleContestantVisibility(contestant.user_id)}
                      >
                        <MDBIcon icon={contestant.visible ? 'eye-slash' : 'eye'} />{' '}
                        {contestant.visible ? 'Hide' : 'Show'}
                      </MDBBtn>
                      {contestant.manuallyAdded && (
                        <MDBBtn
                          type='button'
                          color='danger'
                          size='sm'
                          className='px-2 py-1'
                          onClick={() => ContestStore.removeContestant(contestant.user_id)}
                        >
                          <MDBIcon icon='trash' />
                        </MDBBtn>
                      )}
                    </>
                  )}
                  {isCompleted && (
                    <span className={contestant.visible ? 'text-success' : 'text-muted'}>
                      {contestant.visible ? 'Done' : 'Hidden'}
                    </span>
                  )}
                </td>
              )}
            </tr>
          ))}
          {displayContestants.length === 0 && (
            <tr>
              <td colSpan={6} className='text-center text-muted'>
                No contestants loaded. Select a week to load bar-breakers.
              </td>
            </tr>
          )}
        </MDBTableBody>
      </MDBTable>
    </div>
  )
})

export default Contestants
